<!-- 存放组装单商品-->
<template>
  <div
    class="warehouseOut"
    v-loading="pageLoading"
  >
    <div class="warehouseOut-main">
      <div class="div-table-row table-title">
        <div
          class="div-table-cell"
          style="width: 20%"
        >配件名称</div>
        <div
          class="div-table-cell"
          style="width: 20%"
        >配件配件</div>
        <div
          class="div-table-cell flex"
          style="width: 60%"
        >
          <div
            class="border-right cell-item"
            style="width: 30%"
          >仓库</div>
          <div
            class="border-right cell-item"
            style="width: 30%"
          >仓位</div>
          <div
            class="border-right cell-item"
            style="width: 20%"
          >数量</div>
          <div
            class="cell-item"
            style="width: 20%"
          ></div>
        </div>
      </div>
      <div class="table-main">
        <div
          class="div-table-row"
          v-for="(item,index) in dataList"
          :key="item.EntpTempGoodsId"
        >
          <div
            class="div-table-cell"
            style="width: 20%"
          >{{item.GoodName}}</div>
          <div
            class="div-table-cell"
            style="width: 20%"
          >{{item.APCode}}</div>
          <div
            class="div-table-cell"
            style="width: 60%"
          >
            <div
              class="cell-line"
              v-for="(warehouse,i) in item.GoodsLocationList"
              :key="i.key"
            >
              <div
                class="border-right cell-item"
                style="width: 30%"
              >
                <el-select
                  v-model="warehouse.WarehouseId"
                  :loading="loading"
                  size="small"
                  filterable
                  clearable
                  remote
                  @change="warehouseChange($event,item,warehouse)"
                >
                  <el-option
                    v-for="(optionItem,index) in WarehouseList"
                    :label="optionItem.WarehouseName"
                    :value="optionItem.WarehouseId"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="border-right cell-item"
                style="width: 30%"
              >
                <el-select
                  v-model="warehouse.ShelfSpaceId"
                  :loading="loading"
                  filterable
                  clearable
                  remote
                  reserve-keyword
                  no-match-text="无仓位"
                  :remote-method="(val)=>remoteMethod(val,warehouse.WarehouseId,warehouse)"
                  @change="positionChange($event, item, warehouse)"
                  @visible-change='positionVisibleChange($event,warehouse.WarehouseId,warehouse)'
                  size="small"
                >
                  <el-option
                    v-for="optionItem in warehouse.ShelfSpacesList"
                    :key="optionItem.ShelfSpaceId"
                    :label="optionItem.ShelfSpaceCode"
                    :value="optionItem.ShelfSpaceId"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="border-right cell-item"
                style="width: 20%"
              >
                <el-input
                  size="small"
                  type="number"
                  v-model="warehouse.Count"
                  :max="warehouse.CountMax"
                >e</el-input>
              </div>
              <div
                class="cell-item ops-ctn"
                style="width: 20%;height:28px;margin-top: 7px;"
              >
                <el-button
                  size="mini"
                  icon="el-icon-minus"
                  @click="delItem(index,i)"
                ></el-button>
              </div>
            </div>
          </div>
          <el-button
            size="mini"
            icon="el-icon-plus"
            class="add-btn ops-btn"
            @click="addItem(index)"
          ></el-button>
        </div>
      </div>
    </div>
    <div class="dialog-footer">
      <el-button
        size="small"
        @click="cancel"
      >取消</el-button>
      <el-button
        class="btn-primary"
        size="small"
        @click="submitData"
      >入仓</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "storeSetOrderGoods",
  props: ["goodsList", "setOrderId"],
  components: {},
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg: userMsg,
      Limit: 10,
      pageLoading: false,
      loading: false,
      WarehouseIdEdit: "",
      WarehouseList: [],
      PositionList: [],
      formData: {
        EntpId: userMsg.EntpId,
        SetOrderId: this.setOrderId,
        UserId: userMsg.EmployeeId,
        DetailList: [
          {
            EntpTempGoodsId: "",
            GoodName: "",
            GoodsLocationList: [
              {
                ShelfSpaceId: "",
                Count: ""
              }
            ]
          }
        ]
      },
      dataList: []
    };
  },
  mounted() {
    let _data = {
      WarehouseName: "",
      ShelfSpaceCode: "",
      ShelfSpaceId: "",
      Count: "",
      CountMax: 999,
      ShelfSpacesList: []
    };
    let that = this;
    let _APList = [];
    for (let i = 0; i < that.goodsList.length; i++) {
      _data.Count = that.goodsList[i].Count;
      _data.CountMax = that.goodsList[i].Count;
      // that.goodsList[i].GoodsLocationList = [{ ..._data }];
      this.$set(that.goodsList[i], "GoodsLocationList", [{ ..._data }]);
      _APList.push(that.goodsList[i]);
    }
    that.dataList = _APList;
    that.getWarehouse();
  },
  methods: {
    // 搜仓位
    searchPosition(key, warehouseId) {
      let that = this;
      if (!warehouseId || that.loading) return;
      that.loading = true;
      return that.$util
        .GetShelfSpacesList( {
            WarehouseId: warehouseId,
            ShelfSpaceCode: key,
            Limit: 20,
            IsLimit: true,
            IncludecWaste:true
          })
        .then(res => {
          that.loading = false;
          if (res.data && res.data.length > 0) {
            that.PositionList = res.data;
          } else {
            that.$util.warningMsg("该仓库暂无仓位");
          }
        })
        .catch(() => {
          that.loading = false;
        });
    },
    // 获取仓库列表
    getWarehouse() {
      this.$util.getWarehouse().then(data => {
        this.WarehouseList = data;
      });
    },
    cancel() {
      this.$emit("closeDialog");
    },
    submitData() {
      let _data = this.dataList;
      for (let i = 0; i < _data.length; i++) {
        let PV = _data[i].Count;
        let EV = 0;
        for (let j = 0; j < _data[i].GoodsLocationList.length; j++) {
          if (!_data[i].GoodsLocationList[j].ShelfSpaceId) {
            this.$util.warningMsg("请选择仓位");
            return;
          }
          EV += Number(_data[i].GoodsLocationList[j].Count);
        }
        if (PV != EV) {
          this.$util.warningMsg("入库数量与列表填写不相等");
          return;
        }
      }
      this.pageLoading = true;
      this.formData.DetailList = this.dataList;
      this.$util
        .axiosPost({
          url: "/api/EntpGoods/StoreSetOrderGoods",
          data: this.formData,
          hideLoading: true
        })
        .then(res => {
          this.$util.successMsg("存放商品成功！");
          this.$emit("closeDialog", true);
        })
        .catch(() => {
          this.pageLoading = false;
        });
    },
    // positionChange(value, index, i) {
    //   let flag = 0;
    //   let _data = { ...this.dataList[index] };
    //   let target = _data.GoodsLocationList[i].positionList
    //     ? _data.GoodsLocationList[i].positionList
    //     : [];
    //   for (let j = 0; j < _data.GoodsLocationList.length; j++) {
    //     if (_data.GoodsLocationList[j].ShelfSpaceId == value) {
    //       flag += 1;
    //       if (flag >= 2) {
    //         _data.GoodsLocationList[j].ShelfSpaceId = "";
    //         this.$util.warningMsg("不能选相同仓位");
    //         return;
    //       }
    //     }
    //   }
    // },
    //仓位的变换:选中值、商品、仓位
    positionChange(value, goods, shelfSpace) {
      if (!value) return;
      let that = this;
      let flag = 0;
      goods.GoodsLocationList.forEach(e => {
        if (e.ShelfSpaceId == value) {
          flag++;
          if (flag > 1) {
            shelfSpace.ShelfSpaceId = "";
            that.$util.warningMsg("同个商品不能选相同仓位");
            return;
          }
        }
      });
    },
    //仓位下拉框出现/隐藏时触发
    positionVisibleChange(val, warehouseId, shelfSpace) {
      if (!val || !warehouseId) return;
      let that = this;
      if (
        !(shelfSpace.ShelfSpacesList && shelfSpace.ShelfSpacesList.length > 0)
      ) {
        that.searchPosition("", warehouseId).then(() => {
          that.$set(shelfSpace, "ShelfSpacesList", [...that.PositionList]);
        });
      }
    },
    remoteMethod(val, warehouseId, shelfSpace) {
      if (!val || !warehouseId) return;
      let that = this;
      that.searchPosition(val, warehouseId).then(() => {
        that.$set(shelfSpace, "ShelfSpacesList", [...that.PositionList]);
      });
    },
    warehouseChange(value, goods, warehouse) {
      // let that=this;
      //       warehouse.ShelfSpaceId="";
      //       if(value){
      //           for(let i = 0; i < goods.WarehouseList.length; i++){
      //               if(goods.WarehouseList[i].WarehouseId==value){
      //                   warehouse.positionList=goods.WarehouseList[i].GoodsLocationList;
      //                   return;
      //               }
      //           }
      //       }else{
      //           warehouse.positionList=[];
      //       }
      warehouse.ShelfSpacesList = [];
      warehouse.ShelfSpaceId = "";
    },
    delItem(index, i) {
      let _data = { ...this.dataList[index] };
      if (_data.GoodsLocationList.length != 1) {
        _data.GoodsLocationList.splice(i, 1);
      }
      this.$set(this.dataList, index, _data);
    },
    addItem(index) {
      let that = this;
      let _target = that.dataList[index].GoodsLocationList;
      let _count = 0;
      for (let i = 0; i < _target.length; i++) {
        if (!_target[i].ShelfSpaceId) {
          that.$util.warningMsg("请选择仓位");
          return;
        }
        if (!_target[i].Count || !Number(_target[i].Count) < 0) {
          that.$util.warningMsg("请填写正确的数量");
          return;
        }
        _count += Number(_target[i].Count);
      }
      if (_count >= Number(that.dataList[index].Count)) {
        that.$util.warningMsg("已达到商品可存放的数量上限！");
        return;
      }
      let _data = { ...that.dataList[index] };
      _data.GoodsLocationList.push({
        WarehouseName: "",
        ShelfSpaceCode: "",
        ShelfSpaceId: "",
        Count: Number(that.dataList[index].Count) - _count,
        ShelfSpacesList: []
      });
      that.$set(that.dataList, index, _data);
    }
  }
};
</script>
<style lang="less" scoped>
.add-btn {
  position: absolute;
  right: 10px;
  bottom: 6px;
}
.ops-ctn {
  text-align: left !important;
}
.dialog-footer {
  text-align: right;
  margin-top: 20px;
}
.warehouseOut-main {
  padding-top: 20px;
}
.table-title {
  .cell-item {
    width: 33.33%;
  }
  .div-table-cell {
    text-align: center;
    height: 30px;
    line-height: 30px;
  }
}
.div-table-row {
  position: relative;
  overflow: visible;
}
.table-main {
  .div-table-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  .cell-line {
    display: flex;
    width: 100%;
  }
  .cell-item {
    padding: 0 10px;
    width: 33%;
    width: inherit;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
}
</style>
